import { decode } from "blurhash";
import { ref, watch, type MaybeRef, toValue } from "vue";

export function useBlurhash(
  blurhash: MaybeRef<string | undefined | null>,
  width = 32,
  height = 32,
) {
  const dataUrl = ref<string>();

  const decodeBlurhash = (hash: string) => {
    try {
      // Decode blurhash to pixel array
      const pixels = decode(hash, width, height);

      // Create canvas and draw pixels
      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;

      const ctx = canvas.getContext("2d");
      if (!ctx) return;

      const imageData = ctx.createImageData(width, height);
      imageData.data.set(pixels);
      ctx.putImageData(imageData, 0, 0);

      // Convert to data URL
      dataUrl.value = canvas.toDataURL();
    } catch (error) {
      // oxlint-disable-next-line no-console
      console.error("Failed to decode blurhash:", error);
    }
  };

  watch(
    () => toValue(blurhash),
    (hash) => {
      if (hash) decodeBlurhash(hash);
    },
    { immediate: true },
  );

  return { dataUrl };
}
